import styled from 'styled-components';

export const SearchOption = styled.div`
  display: flex;
  align-items: center;
  color: #243033;

  & > button {
    margin-left: 10px;
  }
`;
